import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.074 6.527c.164-.52.656-.902 1.23-.902h3.364c.574 0 1.066.383 1.23.902l.301.848h2.051c.957 0 1.75.793 1.75 1.75v7c0 .984-.793 1.75-1.75 1.75H6.75c-.984 0-1.75-.766-1.75-1.75v-7c0-.957.766-1.75 1.75-1.75h2.023zM12 10c-.957 0-1.805.52-2.297 1.313a2.65 2.65 0 0 0 0 2.624A2.65 2.65 0 0 0 12 15.25c.93 0 1.777-.492 2.27-1.312a2.64 2.64 0 0 0 0-2.626C13.777 10.52 12.93 10 12 10"
    }, null, -1)
  ]))]))
}
export default { render: render }